import { render, staticRenderFns } from "./CompanyDesktopMultiEmployees.vue?vue&type=template&id=23bd9283"
import script from "./CompanyDesktopMultiEmployees.vue?vue&type=script&lang=js"
export * from "./CompanyDesktopMultiEmployees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports